import { useGetAdjustedMainValues } from '@/ducks/addOns/hooks';
import useStrikethrough from '@/ducks/programs/strikethrough/useStrikethrough';
import useFlowType from '@/features/flowType/useFlowType';
import useParsedData from '@/hooks/useParsedData';
import { useAppSelector } from '@/store';

import { selectCalcMainValues } from './calcMainValuesSelector';

const useCalcMainValues = ({
  isPayInFullPromoAppliedWhenAvailable = false,
}: {
  isPayInFullPromoAppliedWhenAvailable?: boolean; // handle the case when user is on payment+ page (temporary)
} = {}) => {
  const { isMNVV } = useFlowType();
  const { chosenSubCategoryCode } = useParsedData();
  const getStrikethroughForPackage = useStrikethrough();
  const strikethroughValue = getStrikethroughForPackage(chosenSubCategoryCode);
  const props = useAppSelector((state) =>
    selectCalcMainValues(state, isMNVV, strikethroughValue, isPayInFullPromoAppliedWhenAvailable),
  );
  return useGetAdjustedMainValues(props) as typeof props & { originalGratuityAmount: number };
};

export default useCalcMainValues;
